import { render, staticRenderFns } from "./RefuseCrea.vue?vue&type=template&id=5373fa7f&scoped=true&"
import script from "./RefuseCrea.vue?vue&type=script&lang=js&"
export * from "./RefuseCrea.vue?vue&type=script&lang=js&"
import style0 from "./RefuseCrea.vue?vue&type=style&index=0&id=5373fa7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373fa7f",
  null
  
)

export default component.exports